module.exports = "<p>\n  newuser works!\n</p>\n"